import styled from 'styled-components'
import { font, bp } from 'lib/core/resources/helpers/styled'
import { link, heading2 } from 'app/livbrite/resources/theme/css'

export const Wrapper = styled.div`
  label {
    text-transform: uppercase;
    font: ${font('default', 'bold', '22px/30px')};
    color: ${props => props.theme.palette.general.strong};
    ${bp('sm')`
      font-size: 18px;
    `}
  }

  input {
    background: transparent;
    border: none;
    border-bottom: 2px solid ${props => props.theme.palette.general.greyDark};
    border-radius: 0;
    font-size: 18px;
  }

  button {
    width: 100%;
  }
`

export const Heading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${props => props.theme.palette.primary.alphaDark};
  margin-bottom: 15px;
  ${bp('sm')`
    flex-wrap: wrap;
  `}

  h1 {
    ${heading2}
  }

  span {
    text-align: right;
    font: ${font('default', 'medium', '18px/25px')};
    ${bp('sm')`
      font-size: 16px;
    `}

    .action {
      text-decoration: underline;
      cursor: pointer;
      display: block;
      color: ${props => props.theme.palette.primary.alphaDark};
    }
  }
`

export const ForgotPassword = styled.div`
  font: ${font('default', 'medium', '16px/35px')};
  transform: translateY(-20px);
  text-align: right;
  user-select: none;

  a {
    ${link}
  }
`
